import Vue from 'vue'
import VueRouter from 'vue-router'
// Layouts
import App from '../layouts/App.vue'
import Auth from '../layouts/Auth.vue'
// Views
import Asistencias from '../views/Asistencias.vue'
import NoProgramados from '../views/NoProgramados.vue'
import MisAsistencias from '../views/MisAsistencias.vue'
// Services
import { session } from '../services/session'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/asistencias'
  },
  {
    path: '/app',
    name: 'App',
    component: App,
    beforeEnter (to, from, next) {
      if (session.active) {
        return next()
      }

      next('/auth')
    },
    children: [
      {
        path: '/asistencias',
        name: 'Asistencias',
        meta: {
          title: 'Asistencias'
        },
        component: Asistencias
      },
      {
        path: '/no-programados',
        name: 'No Programados',
        meta: {
          title: 'No programados'
        },
        component: NoProgramados
      },
      {
        path: '/mis-asistencias',
        name: 'Mis asistencias',
        meta: {
          title: 'Mis asistencias'
        },
        component: MisAsistencias
      }
    ]
  },
  {
    path: '/auth',
    name: 'Auth',
    meta: {
      title: 'Login'
    },
    component: Auth
  },
  {
    path: '*',
    redirect: '/asistencias'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  document.title = `${to.meta.title} - SISControl`
  next()
})

export default router
